module.exports = __webpack_public_path__ + "media/fonts/Oricons-a97fe0fcb54752be0df274176ef1ea92.ttf";